import { SearchContextAPI } from "../context/SearchContext";
import { useContext } from "react";

const useSearchContext = () => {
  const context = useContext(SearchContextAPI);
  return context
};

export default useSearchContext;
